import { useTranslation } from 'react-i18next';
import { useAppSelector } from '@store';
import { errorProductsSelector } from '@store/slices/cart';

import { ErrorSection } from '@components/ProductList/components/ErrorSection';
import {
  createDataForMergeCartError,
  createTitleFromRemovedProductsNames,
} from '@components/ProductList/utils';
import { MarketRestrictionError } from './MarketError';

export const ErrorNotifications = () => {
  const { t } = useTranslation();
  const { mergedProducts, removedProducts, marketRestrictedProducts } = useAppSelector(errorProductsSelector);
  const removedProductsTitle = createTitleFromRemovedProductsNames(removedProducts);
  const { displayName, productsTitles } = createDataForMergeCartError(mergedProducts);

  return (
    <>
      {!!mergedProducts.length && (
        <ErrorSection
          title={t('cart.productList.errorMergeCart', {
            displayName,
            productsTitles,
          })}
        />
      )}
      {!!removedProducts.length && (
        <ErrorSection
          title={`${removedProductsTitle}${t(
            'cart.productList.errorSectionText',
          )}`}
        />
      )}

      {!!marketRestrictedProducts.length && (
        <MarketRestrictionError products={marketRestrictedProducts} />
      )}
    </>
  );
};
